import { HomeCalendarGranularity } from "../../../models/home";

export class CalendarDateOperations {
  static toDateKey(value: Date | string): string {
    if (typeof value === "string") {
      const isoMatch = value.match(/^(\d{4}-\d{2}-\d{2})/);
      if (isoMatch) {
        return isoMatch[1];
      }

      return CalendarDateOperations.toDateKey(new Date(value));
    }

    const year = value.getFullYear();
    const month = String(value.getMonth() + 1).padStart(2, "0");
    const day = String(value.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  static parseDateKey(value?: string | null): Date {
    if (value) {
      const match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (match) {
        return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]), 12, 0, 0, 0);
      }
    }

    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 12, 0, 0, 0);
  }

  static shiftAnchorDate(
    anchorDateKey: string,
    granularity: HomeCalendarGranularity,
    direction: number
  ): string {
    const nextDate = new Date(CalendarDateOperations.parseDateKey(anchorDateKey));

    switch (granularity) {
      case "week":
        nextDate.setDate(nextDate.getDate() + direction * 7);
        break;
      case "year":
        nextDate.setFullYear(nextDate.getFullYear() + direction);
        break;
      case "month":
      default:
        nextDate.setMonth(nextDate.getMonth() + direction);
        break;
    }

    return CalendarDateOperations.toDateKey(nextDate);
  }
}
